export default __webpack_public_path__ + "static/media/notfound.ced869d1.mp4";